import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const CivilService = {
    async pesquisar(postData) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `civil/pesquisar`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return response.message;
    },

    async alterarDataCorp(postData){
        postData.append("_method", "PUT");
        const response = await BaseService.fetchResponseFromAPIPost(
            `pessoa/datainicorp`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return response.message;
    }


}